import Vue from 'vue';

import router from './routes.js';

import {BootstrapVue} from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);

require('./bootstrap');

import {ValidationObserver, ValidationProvider, extend, localize} from "vee-validate";
import ru from "vee-validate/dist/locale/ru.json";
import * as rules from "vee-validate/dist/rules";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

localize('ru', ru);

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

new Vue({
    router,
    components: {
        Cart: () => import('../frontend/modules/cart/src/Cart'),
        CartPage: () => import('../frontend/modules/cart/src/CartPage'),
        CartQuantity: () => import('../frontend/modules/cart/src/CartQuantity'),
        Buy: () => import('../frontend/modules/cart/src/Buy'),
        Buy2: () => import('../frontend/modules/cart/src/Buy2'),
        BuyWrap: () => import('../frontend/modules/cart/src/BuyWrap'),
        BuyWrap2: () => import('../frontend/modules/cart/src/BuyWrap2'),
        FeedbackModal: () => import('./components/FeedbackModal'),
        ProductQuantity: () => import('../frontend/src/ProductQuantity'),
        ProfileForm: () => import('../frontend/modules/cabinet/views/profile/ProfileForm'),
        AccountForm: () => import('../frontend/modules/cabinet/views/account/AccountForm'),
        Fav: () => import('../frontend/modules/cabinet/modules/fav/src/Fav'),
        FavButton: () => import('../frontend/modules/cabinet/modules/fav/src/FavButton'),
        ProductList: () => import('../frontend/src/product/ProductList'),
        Search: () => import('../frontend/src/Search'),
        Login: () => import('../frontend/modules/auth/views/login/Login'),
        PasswordInput: () => import('./components/PasswordInput'),
    },
    data() {
        return {}
    }
}).$mount('#app');
